import { Box, Button, Checkbox, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControlLabel, FormGroup, IconButton, MenuItem, Modal, Snackbar, Stack, Switch, Tab, TablePagination, Tabs, TextField, Typography } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useReducer } from "react";
import DeleteIcon from '@mui/icons-material/Delete';
import { Download } from "@mui/icons-material";
import MuiAlert from '@mui/material/Alert';
import ApiServices from "../services/ApiServices";
import { isAdmin } from "../components/Constants";
const style = {
    marginTop: '10px',
    width: '100%'
}

const modelStyle = {
    position: 'absolute',
    top: '30%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'fit-content',
    bgcolor: 'background.paper',
    border: '2px solid #1a6ebc',
    borderRadius: '10px',
    boxShadow: 24,
    p: 4,
    '& .MuiTextField-root': { m: 1, width: '25ch' }
};


function Firmware(props) {

    const columns = [
        {
            field: 'type', headerName: 'Type', flex: 0.5, sortable: false, renderCell: (params) => {
                const typeLabels = { APP: "Firmware", BL: "Bootloader", APP_V2: "Firmware_v2", APP_V3: "Firmware_v3" };
                return <div>{typeLabels[params.row.type] ?? params.row.type}</div>;
            }
        },
        { field: 'version', headerName: 'Version', flex: 0.5 , sortable: false,renderCell: (params) => {
            if(params.row.released) return <div>{params.row.version}</div>
            else return <div>{params.row.version} Not Released</div>
        }},
        { field: 'mcu_type', headerName: 'MCU Type', flex: 0.5 , sortable: false},
        { field: 'crc', headerName: 'CRC', flex: 0.5, sortable: false },
        { field: 'fw_crc', headerName: 'FW CRC', flex: 0.5, sortable: false },
        { field: 'fw_len', headerName: 'FW Length', flex: 0.5, sortable: false },
        {
            field: 'released_on', headerName: 'Created At', flex: 0.5, headerAlign: 'center', sortable: false,
            renderCell: (params) => {
                return new Date(params.row.released_on).toLocaleString()
            }
        },
        {
            field: 'created_by', headerName: 'Created By', flex: 0.5, sortable: false
        },
        {
            field: "action",
            headerName: "Action",
            sortable: false,
            flex: 0.5,
            align: 'center',
            headerAlign: 'center',
            hide: !isAdmin(),
            renderCell: (params) => {
                return (
                    <div>
                        <IconButton aria-label="delete" sx={{ m: 1 }} onClick={(e) => onDeleteFimware(e, params.row)} >
                            <DeleteIcon sx={{ textAlign: 'center', color: 'red' }} />
                        </IconButton>
                        <IconButton aria-label="download" onClick={(e) => onDownloadFirmware(e, params.row)} >
                            <Download style={{ color: "#1976d2" }} />
                        </IconButton>
                    </div>
                );
            }
        }
    ];

    const [firmware, setFirmware] = React.useState([])

    //TO open and close the model

    const handleOpen = () => setOpen(true);
    const handleClose = () => { setOpen(false); setDebugMode(false); };
    const [open, setOpen] = React.useState(false);
    const typeUse = [
        { value: "firmware",   label: "Firmware"    },
        { value: "firmware_v2",label: "Firmware_v2" },
        { value: "firmware_v3",label: "Firmware_v3" },
        { value: "bootloader", label: "Bootloader"  },
    ];

    const [uploadTab, setUploadTab] = React.useState(0);

    const UPLOAD_TAB_TYPES = ['firmware', 'mesh1', 'mesh2', 'citycabinet::1.0', 'citycabinet::2.0', 'skyhub'];

    const handleUploadTabChange = (_, newValue) => {
        setUploadTab(newValue);
        setChangesFirmware(UPLOAD_TAB_TYPES[newValue]);
        setChangeMcuType('');
        setFormInput({ type: UPLOAD_TAB_TYPES[newValue], version: '', mcuType: '', file: null, released: false });
    };

    const IOT_MCU_TYPES = [
        { value: "STM32F103_512", label: "STM32F103_512" },
        { value: "STM32L451_512", label: "STM32L451_512" },
        { value: "GD32F303_512",  label: "GD32F303_512"  },
        { value: "STM32F103_256", label: "STM32F103_256" },
        { value: "STM32F103_128", label: "STM32F103_128" },
    ];

    const MESH1_MCU_TYPES = [
        { value: "JN_5148", label: "Jennic 5148" },
        { value: "JN_5168", label: "Jennic 5168" },
        { value: "M_G64",   label: "M_G64"       },
        { value: "M_G128",  label: "M_G128"      },
        { value: "M_LG",    label: "M_LG"        },
    ];

    const MESH2_MCU_TYPES = [
        { value: "M_GD512", label: "M_GD512"     },
        { value: "JN_5168", label: "Jennic 5168" },
    ];

    const CITYCABINET_MCU_TYPES = [
        { value: "ESP_GATEWAY",           label: "ESP Gateway"           },
        { value: "CC_CABINET_CONTROLLER", label: "CC Cabinet Controller" },
        { value: "COO_ZIGBEE_COORDINATOR",label: "COO Zigbee Coordinator"},
    ];

    const SKYHUB_MCU_TYPES = [
        { value: "COO_ZIGBEE_COORDINATOR", label: "COO Zigbee Coordinator" },
        { value: "ESP_GATEWAY",            label: "ESP Gateway"            },
    ];

    const getMcuTypes = (tab) => {
        if (tab === 1) return MESH1_MCU_TYPES;
        if (tab === 2) return MESH2_MCU_TYPES;
        if (tab === 3 || tab === 4) return CITYCABINET_MCU_TYPES;
        if (tab === 5) return SKYHUB_MCU_TYPES;
        return IOT_MCU_TYPES;
    };

    const VERSION_HINTS = {
        1: 'Format: x.y  (e.g. 1.0)',
        2: 'Format: x.y.z  (e.g. 1.0.11)',
    };

    const checkHeader = (response) => {
        if (response.headers['x-total']) {
            return Number(response.headers['x-total'])
        }
        else {
            return Number(0)
        }
    }

    const onDeleteFimware = (e, row) => {
        e.stopPropagation();
        openAlert(row);
    };
    const onDownloadFirmware = (e, row) => {
        e.stopPropagation();
        ApiServices.downloadFirmware(row.type, row.version, row.mcu_type)
            .then(
                response => {
                    if (response.status === 200) {
                        const file = new File([response.data], { type: 'text/plain' });
                        const element = document.createElement("a");
                        element.href = URL.createObjectURL(file);
                        element.download = row.mcu_type + ".bin";
                        document.body.appendChild(element);
                        element.click();
                    }

                }
            )
            .catch(error => {
                console.error(error);
                setSnackBar({ flag: true, message: error.response?.data ?? error.message, severity: "error" });
            })
    }

    const [Alert, setOpenAlert] = React.useState(false);
    const [deleting, setDeleting] = React.useState(false);

    const [rowFirmware, deleteFirmware] = React.useState();

    const openAlert = (row) => {
        setOpenAlert(true);
        deleteFirmware(row);
    };

    const closeAlert = () => {
        setOpenAlert(false);
    };

    const deleteFimware = () => {
        setDeleting(true);
        ApiServices.deleteFirmware(rowFirmware.type, rowFirmware.version, rowFirmware.mcu_type)
            .then(
                response => {
                    searchFirmwareList();
                    setSnackBar({ flag: true, message: "Successfully Deleted", severity: "success" })
                }
            )
            .catch(error => {
                console.error(error);
                setSnackBar({ flag: true, message: error.response?.data ?? error.message, severity: "error" });
            })
            .finally(() => {
                setDeleting(false);
                closeAlert();
            });
    }

    const [debugMode, setDebugMode] = React.useState(false);

    //before submit the form
    const [formInput, setFormInput] = useReducer(
        (state, newState) => ({ ...state, ...newState }),
        {
            type: "firmware",
            version: "",
            mcuType: "",
            file: null,
            released:false
        }
    );

    //ON change of input
    const [changesFirmware, setChangesFirmware] = React.useState('firmware');
    const handleChangeFirmware = (event) => {
        setChangesFirmware(event.target.value);
        setFormInput({ "type": event.target.value, "mcuType": "" });
        setChangeMcuType("");
    };
    const handleInput = evt => {
        const name = evt.target.name;
        const newValue = evt.target.value.trim();        
        if (name === "file") {
            setFormInput({ [name]: evt.target.files[0] });
        } else if(name ==="released"){
            setFormInput({ [name]: evt.target.checked });
        } 
        else {
            setFormInput({ [name]: newValue });
        }
    };

    //on mcuType chnage
    const [changeMcuType, setChangeMcuType] = React.useState("");    
    const handleChangeMcuType = (event) => {
        setChangeMcuType(event.target.value);
        setFormInput({ "mcuType": event.target.value })
    };

    //on submit 
    const formRef = React.useRef();

    const handleSubmit = evt => {
        evt.preventDefault();
        formRef.current.reportValidity();
        if (!formInput.version || !formInput.mcuType) {
            setSnackBar({ flag: true, message: "Please fill the form", severity: "error" })
        }else{
            ApiServices.addFirmware(formInput.type, formInput.version, formInput.mcuType, formInput.file, formInput.released, debugMode)
            .then(
                response => {
                    if (response.status === 201) {
                        handleClose()
                        searchFirmwareList()
                        setSnackBar({ flag: true, message: "Successfully added Firemware", severity: "success" })
                    }
                }
            )
            .catch(error => {
                console.error(error);
                setSnackBar({ flag: true, message: error.response?.data ?? error.message, severity: "error" });
            })
        }
    }
    // On search
    const [searchInput, setSearchInput] = useReducer(
        (state, newState) => ({ ...state, ...newState }),
        {
            type: "",
            version: "",
            mcutype: "",
        }
    );
    const typeUseSearch = [
        {
            value: "None",
            label: "None"
        },
        {
            value: "APP",
            label: "Firmware"
        },
        {
            value: "APP_V2",
            label: "Firmware_v2"
        },
        {
            value: "APP_V3",
            label: "Firmware_v3"
        },
        {
            value: "BL",
            label: "Bootloader"
        },
        {
            value: "MESH1",
            label: "Mesh1"
        },
        {
            value: "MESH2",
            label: "Mesh2"
        },
        {
            value: "citycabinet::1.0",
            label: "CityCABINET 1.0"
        },
        {
            value: "citycabinet::2.0",
            label: "CityCABINET 2.0"
        },
        {
            value: "skyhub",
            label: "SkyHub"
        }
    ];
    const [searchType, setSearchType] = React.useState('None');
    const handleChangeSearch = (event) => {
        setSearchType(event.target.value);
        setSearchInput({ "type": event.target.value })
    };
    const handleSearchInput = evt => {
        const name = evt.target.name;
        const newValue = evt.target.value.trim();
        setSearchInput({ [name]: newValue });
    };
    const searchRef = React.useRef();
    const searchFirmware = evt => {
        evt.preventDefault();
        if (page === 0) {
            searchFirmwareList();
        } else {
            setPage(0);
        }
    }

    // SnackBar 

    const [snackBar, setSnackBar] = React.useState({ flag: false, message: "", severity: "" });
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackBar({ flag: false });
    };
    const AlertSnack = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    // Paginatation 

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [totalRow, setTotalRow] = React.useState(Number);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const searchFirmwareList = () => {
        
        ApiServices.searchFirmware({ "type": searchInput.type, "version": searchInput.version, "mcuType": searchInput.mcutype, "size": rowsPerPage, "page": page })
            .then(response => {
                if (response.data) setFirmware(response.data)
                else setFirmware([])
                setTotalRow(checkHeader(response))
            })
            .catch(error => {
                console.error(error);
                setSnackBar({ flag: true, message: error.response?.data ?? error.message, severity: "error" });
            })
    }
    useEffect(() => {
        searchFirmwareList()
    }, [page, rowsPerPage])
    let button;
    if (isAdmin()) {
        button = <Button variant="contained" sx={{ float: "right" }} onClick={handleOpen}>Add</Button>;
    }
    return (
        <Container maxWidth='xl'>
            <Stack sx={{ width: '100%' }}>
                <Snackbar open={snackBar.flag} autoHideDuration={3000} anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }} onClose={handleCloseSnack}>
                    <AlertSnack onClose={handleCloseSnack} severity={snackBar.severity} sx={{ width: '100%' }}>
                        {snackBar.message}
                    </AlertSnack>
                </Snackbar>
            </Stack>
            <Dialog
                open={Alert}
                onClose={closeAlert}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Are You Sure?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        This firmware will be deleted.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeAlert}>Disagree</Button>
                    <Button onClick={deleteFimware} disabled={deleting} autoFocus>
                        Agree
                    </Button>
                </DialogActions>
            </Dialog>

            <Box mt={5} sx={{ height: 580, width: '100%' }} justifyContent='center'>

                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={modelStyle}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Add Firmware
                        </Typography>

                        <Tabs value={uploadTab} onChange={handleUploadTabChange} sx={{ mt: 1 }}>
                            <Tab label="IoT" />
                            <Tab label="Mesh1" />
                            <Tab label="Mesh2" />
                            <Tab label="CityCABINET 1.0" />
                            <Tab label="CityCABINET 2.0" />
                            <Tab label="SkyHub" />
                        </Tabs>
                        <Divider />

                        <Typography component="div" id="modal-modal-description" sx={{ mt: 2, '& .MuiTextField-root': { m: 1, width: '25ch' } }}>
                            <form key={uploadTab} onSubmit={handleSubmit} ref={formRef} noValidate autoComplete="off">

                                {/* IoT tab — firmware sub-type selector */}
                                {uploadTab === 0 && (
                                    <TextField
                                        variant="standard"
                                        id="select-firmware"
                                        select
                                        label="Firmware Type"
                                        value={changesFirmware}
                                        onChange={handleChangeFirmware}
                                        margin="normal"
                                        name="type"
                                        required
                                    >
                                        {typeUse.map(option => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}

                                                <TextField
                                        required
                                        id="select-mcutype"
                                        name="mcuType"
                                        label="MCU Type"
                                        variant="standard"
                                        onChange={handleChangeMcuType}
                                        select
                                        margin="normal"
                                        value={changeMcuType}
                                    >
                                        <MenuItem value=''>Please select MCU Type</MenuItem>
                                        {getMcuTypes(uploadTab).map(opt => (
                                            <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                                        ))}
                                    </TextField>

                                <br />

                                <TextField
                                    required
                                    name="version"
                                    label="Version"
                                    variant="standard"
                                    onChange={handleInput}
                                    helperText={debugMode ? 'Debug: any version accepted' : (VERSION_HINTS[uploadTab] ?? '')}
                                />

                                <TextField required name="file" label="File" type="file" variant="standard" onChange={handleInput} />
                                <br />
                                <FormGroup>
                                    <FormControlLabel control={<Checkbox name="released" onChange={handleInput} />} label="Released" />
                                    <FormControlLabel control={<Switch checked={debugMode} onChange={e => setDebugMode(e.target.checked)} size="small" />} label="Debug" />
                                </FormGroup>
                                <Button sx={{ m: 1, float: 'right' }} type="submit" variant="contained">Submit</Button>
                            </form>
                        </Typography>
                    </Box>

                </Modal>


                <Box
                    component="form"
                    sx={{
                        '& > :not(style)': { m: 1, flex: 1 },
                    }}
                    noValidate
                    autoComplete="off"
                    ref={searchRef}
                >
                    <TextField
                        variant="outlined"
                        select
                        value={searchType}
                        onChange={handleChangeSearch}
                        size="small"
                    >
                        {typeUseSearch.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField name="version" size="small" label="Version" variant="outlined" onChange={handleSearchInput} />
                    <TextField name="mcutype" size="small" label="MCU type" variant="outlined" onChange={handleSearchInput} />
                    <Button variant="contained" color="primary" type="submit" onClick={searchFirmware} >Search</Button>                    
                    {button}                    
                </Box>
                <DataGrid
                    sx={style}
                    rows={firmware}
                    getRowId={(row) => row.released_on}
                    columns={columns}
                    autoHeight={true}
                    disableColumnMenu
                    hideFooter={true}
                />
                <TablePagination
                    component="div"
                    count={totalRow}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Box>
        </Container>
    );
}

export default Firmware